import { createRoutine } from 'redux-saga-routines';

export const clearEvents = createRoutine('CLEAR_EVENTS');
export const clearInviteesData = createRoutine('CLEAR_INVITEES_DATA');
export const clearRegistrantsData = createRoutine('CLEAR_REGISTRANTS_DATA');
export const clearSessionsData = createRoutine('CLEAR_SESSIONS_DATA');
export const clearSitePagesData = createRoutine('CLEAR_SITE_PAGES_DATA');
export const fetchActiveMasterEvents = createRoutine('FETCH_ACTIVE_MASTER_EVENTS');
export const fetchActiveMasterEventsFirebase = createRoutine('FETCH_ACTIVE_MASTER_EVENTS_FIREBASE');
export const fetchActiveModules = createRoutine('FETCH_ACTIVE_MODULES');
export const fetchEventInformationFromFB = createRoutine('FETCH_EVENT_INFORMATION_FB');

//No longer used
export const fetchEvents = createRoutine('FETCH_EVENTS');

//Used to obtain single event
export const fetchEvent = createRoutine('FETCH_EVENT');
export const fetchInviteesBatchForEvent = createRoutine('FETCH_INVITEES_BATCH_FOR_EVENT');
export const fetchInviteesForEvent = createRoutine('FETCH_INVITEES_FOR_EVENT');
export const stopFetchInviteesForEvent = createRoutine('STOP_FETCH_INVITEES_FOR_EVENT');
export const fetchEventInviteesCounts = createRoutine('FETCH_EVENT_INVITEES_COUNTS');
export const bgFetchInviteesSync = createRoutine('BACKGROUND_FETCH_INVITEES_SYNC')
export const fetchSessionsForEvent = createRoutine('FETCH_SESSIONS_FOR_EVENT');
export const fetchRegistrantsBatchForEvent = createRoutine('FETCH_REGISTRANTS_BATCH_FOR_EVENT');
export const fetchRegistrantsForEvent = createRoutine('FETCH_REGISTRANTS_FOR_EVENT');
export const fetchSitePagesForEvent = createRoutine('FETCH_SITE_PAGES_FOR_EVENT');
export const saveEventHeroImage = createRoutine('SAVE_EVENT_HERO_IMAGE');
export const stopSyncingEvents = createRoutine('STOP_SYNCING_EVENTS');
export const togglePresenceOfEventInActiveEventsList = createRoutine('TOGGLE_PRESENCE_OF_EVENT_IN_ACTIVE_EVENTS_LIST');
export const updateActiveModule = createRoutine('UPDATE_ACTIVE_MODULE');
export const updateChannelsModule = createRoutine('UPDATE_CHANNELS_MODULE');
export const updatePeerToPeerModule = createRoutine('UPDATE_PEER_TO_PEER_MODULE');
export const updatePeerToPeerVideoChat = createRoutine('UPDATE_PEER_TO_PEER_VIDEO_CHAT');
export const syncGuestListWithActiveUsers = createRoutine('SYNC_GUEST_LIST_WITH_ACTIVE_USERS');

